import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { useTokensQuery } from '@modules/tokens/queries';

import type {
  IPermissionsResponse,
} from '../types';
import {
  PERMISSIONS_API_URL,
  PERMISSIONS_QUERY_KEY,
} from '../constants';
import { usePermissionsStore } from '../store';

export default function usePermissionsQuery(): IContextQueryResult<boolean, Error> {
  const { isSuccess: enabled } = useTokensQuery();
  const { fetchGet } = useRestClient();
  const { setPermissions } = usePermissionsStore();

  return useContextQuery({
    queryKey: [PERMISSIONS_QUERY_KEY],
    refetchOnMount: false,
    gcTime: Infinity,
    staleTime: Infinity,
    queryFn: async ({ signal }) => {
      const data = await fetchGet<IPermissionsResponse>(PERMISSIONS_API_URL, {
        signal,
        isEssential: true,
      });
      setPermissions(Object.values(data.permissions_by_role)[0]);

      return true;
    },
    enabled,
  });
}
